import type { PropsWithChildren } from 'react';
import { useRealmAuthContext } from '@interxfi/api-client';
import { ThemeProvider } from '@interxfi/design-system/theme-context';

export function WrappedThemeProvider({ children }: PropsWithChildren) {
  const authContext = useRealmAuthContext();

  return <ThemeProvider userThemePreference={authContext?.data?.preferences?.theme ?? 'SYSTEM'}>{children}</ThemeProvider>;
}
